
export const SEASONS = [
  {
    id: "spring",
    title: "Pasqua",
    subtitle: "Il Risveglio",
    description: "Nuove collezioni floreali e decorazioni fresche per ogni angolo.",
    palette: {
      sky: ["#a8e6cf", "#dcedc1"],
      sun: "#ffd3b6",
      mountains: "#8fb9a8",
      ground: "#b6e2d3",
      treeTrunk: "#5d4037",
      treeLeaves: "#ffb7b2",
      text: "text-emerald-900", 
      accent: "bg-emerald-600",
    },
    particles: "petals",
    windDirection: 50,
    customImages: {
      mountains: "/far1.webp",
      hills: "/front1.webp",
      treeLeft: "/alberosx1.webp",
      treeRight: "/alberodx1.webp",
    }
  },
  {
    id: "summer",
    title: "Estate",
    subtitle: "La Luce",
    description: "Colori vivaci per la stagione più calda dell'anno.",
    palette: {
      sky: ["#4facfe", "#00f2fe"],
      sun: "#ffeb3b",
      mountains: "#2e7d32",
      ground: "#66bb6a",
      treeTrunk: "#5d4037",
      treeLeaves: "#43a047",
      text: "text-blue-900",
      accent: "bg-blue-600",
    },
    particles: "sunrays",
    windDirection: 0,
    customImages: {
      mountains: "/far2.webp",
      hills: "/front2.webp",
      treeLeft: "/alberosx2.webp",
      treeRight: "/alberodx2.webp",
    }
  },
  {
    id: "autumn",
    title: "Autunno",
    subtitle: "L'Oro",
    description: "Tessuti caldi, pannolenci e decorazioni per la casa che cambia.",
    palette: {
      sky: ["#ff9966", "#ff5e62"],
      sun: "#ffcc80",
      mountains: "#8d6e63",
      ground: "#d7ccc8",
      treeTrunk: "#4e342e",
      treeLeaves: "#e64a19",
      text: "text-orange-950",
      accent: "bg-orange-700",
    },
    particles: "leaves",
    windDirection: -50,
    customImages: {
      mountains: "/far3.webp",
      hills: "/front3.webp",
      treeLeft: "/alberosx3.webp",
      treeRight: "/alberodx3.webp",
    }
  },
  {
    id: "winter",
    title: "Natale",
    subtitle: "Il Silenzio",
    description: "La magia delle feste, idee regalo e caldi abbracci di stoffa.",
    palette: {
      sky: ["#E0F9F9", "#cfd8dc"],
      sun: "#eceff1",
      mountains: "#90a4ae",
      ground: "#eceff1",
      treeTrunk: "#3e2723",
      treeLeaves: "#eceff1",
      text: "text-slate-800",
      accent: "bg-slate-600",
    },
    particles: "snow",
    windDirection: 30,
    customImages: {
      mountains: "/far4.webp",
      hills: "/front4.webp",
      treeLeft: "/alberosx4.webp",
      treeRight: "/alberodx4.webp",
    }
  },
];


export const CATEGORIES = ["Tutti", "Primavera (Pasqua)", "Estate", "Autunno", "Inverno (Natale)", "Amiche di Amy"];
